export const meta: BlockMeta = {
  title: "Text Image Tile",
  tags: ["subpage"],
  flags: {
    fullWidth: true,
  },
}

import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { TextImageThemeTile } from "@components/atoms/TextImageThemeTile"
import { Button } from "@components/ui/Button"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/text-image-tile", (props) => {
  return (
    <TextImageThemeTile
      theme={props.theme || "yellow"}
      image={props.image || undefined}
      edge={props.imageStyle === "yedge"}
      link={props.link && !env.admin ? { url: props.link.url!, target: props.link.target! } : undefined}
    >
      <div className="w-full flex flex-col gap-7">
        <div className="w-full flex flex-col gap-4 [&_.wp-block]:my-0 [&_.block-image]:my-0 [&_.block-image]:-ml-6 [&_.image-caption]:!hidden [&_.block-image]:w-[calc(100%+(var(--spacing-6)*2))] md:[&_.block-image]:-ml-5 md:[&_.block-image]:w-[calc(100%+(var(--spacing-5)*2))] [&_button]:my-0 [&_p]:my-0 [&_.core-rich-text]:flex [&_.core-rich-text]:flex-col [&_.core-rich-text]:gap-4 [&_.wp-block-heading]:my-0 [&_button]:!w-full [&_button]:!justify-start [&_p]:type-body-m">
          <InnerBlocks
            allowedBlocks={["richtext"]}
            orientation="horizontal"
            adminClassName="w-full flex flex-col gap-4"
            template={[
              ["core/heading", { placeholder: "Example title" }],
              ["core/paragraph", { placeholder: "Example text" }],
            ]}
          />
        </div>
      </div>
    </TextImageThemeTile>
  )
})
